import { serializer } from '../serializer.js';
import { MemoryStore } from './MemoryStore.js';
export class ApiCacheStore {
    config;
    memoryStore = new MemoryStore();
    constructor(config) {
        this.config = config;
    }
    async request(key, options) {
        const url = new URL(`/cache/${key.replace(/^\/|\/$/g, '')}/`, this.config.baseUrl);
        const init = {
            ...options,
            headers: {
                ...options?.headers,
                Authorization: `Bearer ${this.config.apiKey}`,
            },
        };
        const response = await (this.config.fetch || fetch)(url.toString(), init);
        const data = response.headers.get('content-type')?.includes('application/json') ? await response.json() : undefined;
        if (!response.ok) {
            const message = data?.message || response.statusText;
            throw new Error(`Failed to fetch ${url.toString()}. ${message}`);
        }
        return data;
    }
    async get(key) {
        const cached = await this.memoryStore.get(key);
        if (cached) {
            return cached;
        }
        const response = await this.request(key);
        if (!response.value) {
            return undefined;
        }
        const value = serializer.parse(response.value);
        if (response.ttl) {
            this.memoryStore.set(key, value, response.ttl).catch(() => undefined);
        }
        return value;
    }
    async set(key, data, ttl) {
        await Promise.all([
            this.memoryStore.set(key, data, ttl),
            await this.request(key, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ttl,
                    data: serializer.stringify(data),
                }),
            }),
        ]);
    }
    async delete(key) {
        await this.request(key, { method: 'DELETE' });
    }
    async ttl(key) {
        const response = await this.request(key);
        return response.ttl || 0;
    }
}
